import { CartUpdateEvent } from '@theme/events';

async function syncCartFromWishlist() {
  const cart = await (await fetch('/cart.js')).json();

  document.dispatchEvent(
    new CartUpdateEvent(cart, 'wishlist-app', {
      source: 'wishlist-app',
      itemCount: cart.item_count,
    })
  );

  document.querySelector('cart-drawer-component')?.open();
}

window.addEventListener('wishlist:updated', (event) => {
  if (event?.detail?.source !== 'auto-remove-on-cart') return;

  syncCartFromWishlist();
});